module.exports = __webpack_public_path__ + "static/SerifGothicStd-ExtraBold-2737b734afac1ed0911240dd738f9ec0.woff";